import { CardBody } from "reactstrap";
import { H5 } from "../../../AbstractElements";
import { Files } from "../../../Constant";
import QuickAccess from "./QuickAccess";
import { FolderSection } from "./FolderSection";
import FileList from "./FileList";
import { FileMainContentPropsType } from "../../../Type/FileManagerType";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";

const FileMainContent = ({ fileList }: FileMainContentPropsType) => {
  const { searchTerm } = useAppSelector((state) => state.filemanager);

  return (
    <CardBody className="file-manager">
      {!searchTerm && (
        <>
          <QuickAccess />
          <FolderSection />
        </>
      )}
      <H5 className="mt-4">{Files}</H5>
      <FileList myFile={fileList}/>
    </CardBody>
  );
};

export default FileMainContent;
